"use client";

import type { BrandConfig, NavItem } from "../../types";

import { LeftSidebar } from "./LeftSidebar";

type MobileSidebarOverlayProps = {
  open: boolean;
  onClose: () => void;
  locale: string;
  brand: BrandConfig;
  navItems: NavItem[];
  locales?: readonly string[];
  languageLabels?: Record<string, string>;
};

export function MobileSidebarOverlay({
  open,
  onClose,
  locale,
  brand,
  navItems,
  locales,
  languageLabels,
}: MobileSidebarOverlayProps) {
  if (!open) return null;

  return (
    <>
      <div
        data-testid="mobile-sidebar-backdrop"
        className="fixed inset-0 z-50 bg-overlay/50 backdrop-blur-[2px] transition-opacity duration-shell ease-shell lg:hidden"
        onClick={onClose}
      />
      <div
        data-testid="mobile-sidebar"
        className="fixed inset-y-0 left-0 z-50 w-[280px] bg-sidebar-bg shadow-shell-lg lg:hidden"
      >
        <LeftSidebar
          locale={locale}
          brand={brand}
          navItems={navItems}
          locales={locales}
          languageLabels={languageLabels}
          onNavClick={onClose}
        />
      </div>
    </>
  );
}
